// Session storage constants
const SALE_DISCOUNT_SETTING = 'WR_SALE_DISCOUNT_IS_PERCENTAGE'

/**
 * Used to manage session storage
 */

/**
 * Determine and return the discountIsPercentage setting
 * Check if there's a saved setting in session storage, otherwise return true
 *
 * @return Returns a boolean based on the session storage value, true otherwise
 */
export function getSaleDiscountIsPercentage(): boolean {
  const isPercentageStoredValue = window.sessionStorage.getItem(
    SALE_DISCOUNT_SETTING
  )
  let discountIsPercentage

  if (isPercentageStoredValue !== null) {
    discountIsPercentage = isPercentageStoredValue === 'true'
  } else {
    discountIsPercentage = true
  }

  return discountIsPercentage
}

/**
 * Set the discountIsPercentage session storage value
 *
 * @method setSaleDiscountIsPercentage
 *
 * @param {Boolean} saleDiscountIsPercentage
 */
export function setSaleDiscountIsPercentage(saleDiscountIsPercentage: boolean) {
  window.sessionStorage.setItem(
    SALE_DISCOUNT_SETTING,
    saleDiscountIsPercentage as any
  )
}
